import React from 'react';
import List from 'containers/rest/List';
import RestFieldItem from 'components/RestField/RestFieldItem';
import ActionGroup from 'components/RestActions/ActionGroup';
import EditButton from 'components/RestActions/EditButton';
import { PreviewHtml } from 'components/RestInput/RestEditor';
import { useSelector } from 'react-redux';
import PreviewImage from 'components/common/PreviewImage';

const PlatformsList = (props) => {
  const productCatalogs = useSelector(
    (state) => state.config?.data?.productType,
  );
  return (
    <List
      {...props}
      defaultOptions={{ customApiResource: 'platforms/me' }}
      resource="platforms"
    >
      <RestFieldItem
        format={(data) =>
          data?.previewImage ? <PreviewImage src={data?.previewImage} /> : ''
        }
        source="productDemoFile"
        header="Preview Image"
      />
      <RestFieldItem source="name" header="platforms.name" />
      <RestFieldItem
        format={(data) => <PreviewHtml html={data} />}
        source="description"
        header="niches.description"
      />
      <RestFieldItem
        width={150}
        format={(data) => productCatalogs?.find((e) => e.id === data)?.name}
        source="productCatalogId"
        header="platforms.productCatalogId"
      />
      <ActionGroup>
        <EditButton />
      </ActionGroup>
    </List>
  );
};

PlatformsList.propTypes = {};

export default PlatformsList;
